<template lang="pug">
    .container
        .loading-container(v-if="wait")
            .loading-button

        .message-title-container(v-else-if="isSuccess")
            img(src="@/assets/images/misc/happy.svg")

            .title-section.success
                h3 Reservation completed successfully.
                p.order Your Order Number:
                    span {{ finalBooking.data.results.id }}

                p A summery of your reservation has been emailed to 
                    span.email {{ finalBooking.data.results.email }}.

        .message-title-container(v-else)
            img(src="@/assets/images/misc/sad.svg")
            
            .title-section.fail
                h3 Oops! Something went wrong.
                p We are sorry, things don’t appear to be working at the moment. Please try again later.

                router-link(to="/checkout") Return to checkout


           
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'Result',
        data() {
            return {
                isSuccess: true,
                wait: true
            }
        },
        computed: mapGetters(['finalBooking', 'getCurrency']),
        methods: {
            ...mapActions(['confirmBooking'])
        },
        created() {

            var data = {
                'booking_id': window.localStorage.getItem('firstStepBookingId'),
                'currency': 'usd'//this.getCurrency
            };

            this.confirmBooking(data).then(() => {
                this.wait = false;

                if(this.finalBooking.status_code == 400) {
                    this.isSuccess = false
                } else {
                    this.isSuccess = true
                }
            });
        }
    }
</script>

<style lang="sass" scoped>
    @import "@/assets/css/2-base/_variables.sass"
    @import "@/assets/css/2-base/_placeholder.sass"

    .loading-container
        position: relative
        height: 300px
</style>